import { render } from "./consentformtemplate.vue?vue&type=template&id=0677811b&scoped=true"
import script from "./consentformtemplate.js?vue&type=script&lang=js"
export * from "./consentformtemplate.js?vue&type=script&lang=js"

import "./consentformtemplate.vue?vue&type=style&index=0&id=0677811b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0677811b"]])

export default __exports__